import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=de18b996&"
import script from "./integrations.vue?vue&type=script&lang=ts&"
export * from "./integrations.vue?vue&type=script&lang=ts&"
import style0 from "./integrations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports